var map = {
	"./Reliance.png": 1688,
	"./gestamp.png": 946,
	"./gulf.png": 8261,
	"./haskoning.png": 7739,
	"./horizon.png": 670,
	"./jindal.png": 1041,
	"./katria.png": 7295,
	"./khrone.png": 3244,
	"./lloyd.png": 5639,
	"./military.png": 5310,
	"./tata.png": 4335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6968;